<template>
    <div>
<!--        <div v-if="zoomLevel" class="row justify-center align-center my-4">-->
<!--            <button-->
<!--                class="zoom__button"-->
<!--                @click="$emit('setZoom', zoomLevel - 0.1)"-->
<!--                @dblclick="$emit('setZoom', zoomLevel - 0.2)"-->
<!--            >-</button>-->
<!--            <div class="px-4">{{ zoomLevel }}x</div>-->
<!--            <button-->
<!--                class="zoom__button"-->
<!--                @click="$emit('setZoom', zoomLevel + 0.1)"-->
<!--                @dblclick="$emit('setZoom', zoomLevel + 0.2)"-->
<!--            >+</button>-->
<!--        </div>-->
        <v-row class="column-layout">
            <v-col
                :class="{
                    active: isActiveCameraTimer
                }"
                @click="handleCameraTimer"
            >
                <camera-timer/>
            </v-col>
            <v-col
                v-if="!disableVideo"
                :class="{
                    active: isActiveSloMo
                }"
                @click="handleSloMo"
            >
                <slo-mo/>
            </v-col>
            <v-col
                :class="{
                    active: isActiveFlashlight
                }"
                @click="handleFlashlight"
            >
                <flashlight />
            </v-col>
            <v-col
                :class="{
                    active: isFrontCamera
                }"
                @click="handleChangeCamera"
            >
                <change-camera/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import CameraTimer from "@/assets/images/icons/new-camera-timer.svg?inline";
import ChangeCamera from "@/assets/images/icons/new-change-camera.svg?inline";
import Flashlight from "@/assets/images/icons/new-flashlight.svg?inline";
import SloMo from "@/assets/images/icons/slow-motion.svg?inline";

export default {
    name: "CameraControlBlock",
    data() {
        return {
            isActiveFlashlight: false,
            localIsActiveSloMo: this.isActiveSloMo,
        }
    },
    props: {
        isFrontCamera: {
            type: Boolean,
            default: false,
        },
        isActiveCameraTimer: {
            type: Boolean,
            default: false,
        },
        isActiveSloMo:{
            type: Boolean,
            default: false,
        },
        disableVideo: {
            type: Boolean,
            default: false,
        },
      // zoomLevel: {
      //     type: Number,
      //     default: null,
      // },
    },
    watch:{
        isActiveSloMo(newValue) {
            this.localIsActiveSloMo = newValue;
        },
    },
    components: {
        CameraTimer,
        ChangeCamera,
        Flashlight,
        SloMo,
    },
    methods: {
        handleChangeCamera() {
            this.isActiveFlashlight = false
            this.$emit('changeCamera')
        },
        handleCameraTimer() {
            this.$emit('cameraTimer')
        },
        handleFlashlight() {
            this.isActiveFlashlight = !this.isActiveFlashlight
            this.$emit('flashlight')
        },
        handleSloMo(){
            this.localIsActiveSloMo = !this.localIsActiveSloMo;
            this.$emit('update:isActiveSloMo', this.localIsActiveSloMo);
        },
    },
}
</script>

<style scoped lang="scss">
svg {
    path {
        fill: #FFFFFF;
    }
}

.active {
    svg {
        path {
            fill: #A46A1F;
        }
    }
}

.zoom__button {
    background: white;
    color: black;
    border-radius: 50%;
    padding: 4px;
    width: 32px;
}

.column-layout {
    flex-direction: column;
    align-items: center;
}

v-col {
    margin: 8px 0; /* Adds spacing between buttons */
}
</style>
